import clsx from 'clsx';

export interface BadgeProps {
  children: React.ReactNode;
  tone?: 'neutral' | 'ok' | 'warn' | 'err' | 'accent' | 'gold';
  className?: string;
}

const TONE_CLASS: Record<NonNullable<BadgeProps['tone']>, string> = {
  neutral: 'bg-panel-2 text-dim',
  ok: 'bg-ok/15 text-ok',
  warn: 'bg-warn/15 text-warn',
  err: 'bg-err/15 text-err',
  accent: 'bg-accent-dim text-accent',
  gold: 'bg-gold/15 text-gold',
};

export function Badge({ children, tone = 'neutral', className }: BadgeProps): JSX.Element {
  return <span className={clsx('badge', TONE_CLASS[tone], className)}>{children}</span>;
}

export default Badge;
